import { observer } from "mobx-react";
import { IStepComponent } from "../../onboarding-page";
import EnableReturnGuardstore from "../../stores/enable-return-guard-store";
import ReturnGuardNavigationControls from "../return-guard-navigation-controls/return-guard-navigation-controls";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";
import EnableReturnGuardShopifyExtension from "./enable-return-guard-shopify-extension/enable-return-guard-shopify-extension";

const EnableReturnGuardOnboardingScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as EnableReturnGuardstore;
        
    return (
        <>
            <EnableReturnGuardShopifyExtension />
            <OnboardingWizardStickyFooterPortal>
                <ReturnGuardNavigationControls
                    onBackClick={store.previousStep}
                    onSetupLaterClick={store.onSetupLaterClick}
                    onNextClick={store.nextStep}
                    onSetupClick={store.onSetupClick}
                    setupButtonHref={store.enableExtensionEmbedBlockURL}
                    showContinueButton={store.showContinueButton}
                    isLoading={store.isLoading}
                />
            </OnboardingWizardStickyFooterPortal>
        </>
    );
 
});

export default EnableReturnGuardOnboardingScreen;